<template>
  <div class="g-page-container">

    <div class="g-pageHeader" style="height: 63px;">
      <h1 style="margin: auto;">{{$t('configDown.title')}}</h1>
    </div>

    <form class="g-pageBody" @submit.prevent="onSubmit">

      <div class="form-group">
        <label for="inputText">{{$t('configDown.text')}}</label>
        <input
          type="text"
          required
          v-model="downtime.text"
          class="form-control"
          id="inputText"
          :placeholder="$t('configDown.textPHolder')">
      </div>

      <div class="form-group">
        <label for="inputLines">{{$t('configDown.lines')}}</label>
        <div id="inputLines">
          <MultipleSelect
            :data="lineList"
            v-model="downtime.linesList"
            multiple
            :options="opt" >
          </MultipleSelect>
        </div>
      </div>

      <div class="form-group">
        <input type="checkbox" id="password" v-model="downtime.needPsw">
        <label class="checkboxLabel" for="password">{{$t('configDown.password')}}</label>
      </div>

      <div class="form-group">
        <input type="checkbox" id="autoMsg" v-model="downtime.autoMsg">
        <label class="checkboxLabel" for="autoMsg">{{$t('configDown.autoMsg')}}</label>
      </div>

      <div class="form-group">
        <input type="checkbox" id="isActive" v-model="downtime.isActive">
        <label class="checkboxLabel" for="isActive">{{$t('configDown.active')}}</label>
      </div>

      <button class="btn btn-perfcell float-left marginTop50px" @click.prevent="clickRetour">
        {{ $t('configDown.cancel' ) }}
      </button>

      <button class="btn btn-perfcell float-left marginTop50px marginLeft10px" type="submit">
        {{ $t('configDown.submit' ) }}
      </button>

      <p v-if="errors.length" class="float-left marginTop50px marginLeft30px" :style="{ color: msgColor }">
        <b v-if="msgColor == 'red'">{{$tc('configDown.error', errors.length)}}</b>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </p>

    </form>

  </div>
</template>

<script>
import { axiosInstance } from "@/main";

export default {
  data() {
    return {
      downtime: {
        _id: '',
        text: '',
        linesList: [],
        needPsw: false,
        autoMsg: false,
        isActive: true
      },
      id: '',
      errors: [],
      msgColor: "red",
      lineList: [],
      opt: {
        multiple: true,
        filter: true,
        placeholder: this.$i18n.t('configDown.linesPHolder'),
        multipleWidth: 500,
        width: 500,
        dropWidth: 500,
        locale: localStorage.getItem("locale")
      }
    }
  },
  methods: {
    onSubmit() {
      if( ! this.validate() )
        return;
      axiosInstance.post('/downtime/' + this.id, this.downtime)
      .then((resp) => {
        //console.log("----- onSubmit ok = " + JSON.stringify(resp.data, null, 2));

        this.downtime = resp.data;
        this.id = this.downtime._id;
        this.errors.push(this.$i18n.t('configDown.success'));
        this.msgColor = "green";
      }).catch((err) => {
        console.log("----- onSubmit error = " + JSON.stringify(err, null, 2));
      });
    },
    validate() {
      this.errors = [];
      this.msgColor = "red";

      this.downtime.text = this.downtime.text.trim();
      if( ! this.downtime.text.length )
        return false;

      return ! this.errors.length;
    },
    clickRetour() {
      this.$router.replace("/configDowntimesList");
    }
  },
  mounted() {
    if( this.id != "0" ) {
      axiosInstance.get('/downtime/' + this.id)
      .then(resp => {
        //console.log("----- get /downtime = " + JSON.stringify(resp.data, null, 2));
        this.downtime = resp.data;
      })
      .catch(err => {
        console.log("----- get /downtime error = " + JSON.stringify(err, null, 2));
      });
    }

    axiosInstance.get('/lineList', {"params": { "isActive": true }})
    .then(resp => {
        for( let i=0; i<resp.data.length; i++ ) {
          resp.data[i].text = resp.data[i].name + ' - ' + resp.data[i].description;
          resp.data[i].value = resp.data[i]._id;
        }
        //console.log("----- get /lineList = " + JSON.stringify(resp.data, null, 2));
        this.lineList = resp.data;
    }).catch(err => {
        console.log("----- get /lineList error = " + JSON.stringify(err, null, 2));
    });
  },
  created() {
    this.id = this.$route.params.id;
    //console.log("----- this.id = " + JSON.stringify(this.id, null, 2));
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/colors.scss';

form {
  background: White;
  padding: 2rem 2rem 1rem;
  width: 100%;
}

label {
  font-weight: bold;
}

.narrow {
  width: 70px;
}
</style>
